export default __webpack_public_path__ + "static/media/subLogo.c2f84ebd.svg";